import React from 'react';
import './WhatIsZip.css'; // Import the custom CSS file

// Import images
import zipquillcloud from '../../assets/img/zipquillcloud.webp';

const WhatIsZip = () => {

    
    return (
      <>
      
        <div className="whatis-list">
        <div className="whatis-content mt-2">
            <p className="whatis-description text-center">
            A Quill offers a simple yet powerful combination of a QR code and a customizable message.
            </p>
          </div>
          <div className="whatis-item mt-2" >
            <img src={zipquillcloud} alt="WhatIsZipQuill" className="whatis-image" /> 
             <div className="whatis-content">
                  <p className="whatis-description text-center">
                  The QR code serves as a direct link to your message. <br />Change it anytime to keep your content current or interactive!
                  </p>
              </div>
          </div>
        </div>
      </>
    );
};

export default WhatIsZip;
